export default __webpack_public_path__ + "static/un-ef53b652b4696296bd6c10d9de1462fd.svg";